import { Html5Qrcode } from 'html5-qrcode';

(window as any).Html5Qrcode = Html5Qrcode;
